<template>
  <!-- <div class="py-2 px-0 text-xs max-w-screen-xl large:max-w-screen-large"> -->

  <WidgetWrapper title="Custom Formula" class="m-2" :full-height="true">
    <div class="w-full mt-4 px-4 pb-4 flex flex-col" v-loading="loading">
      <div class="flex justify-start py-4">
        <el-button
          type="primary"
          @click="$router.push({ name: 'formula-init' })"
          >Add Custom Formula<i class="el-icon-plus"
        /></el-button>
      </div>

      <FormulaList
        :headers="getHeaders()"
        :items="sensorList"
        :customizationPage="customizationPage"
        :options="options"
      />
    </div>
  </WidgetWrapper>
</template>

<script>
import WidgetWrapper from '@/components/WidgetWrapper'
import FormulaList from '@/components/formula/FormulaList'

export default {
  components: {
    FormulaList,
    WidgetWrapper
  },
  data() {
    return {
      selectedRow: '',
      customerList: [],
      formulaList: [],
      sensorList: [],
      sensor: {
        Id: '',
        tenant: '',
        VarName: '',
        operator: '',
        tags: [],
        CompleteFormula: '',
        action: ''
      },
      operators: [
        {
          value: 'avg',
          label: 'Avg'
        },
        {
          value: 'sum',
          label: 'Sum'
        },
        {
          value: 'min',
          label: 'Min'
        },
        {
          value: 'max',
          label: 'Max'
        },
        {
          value: 'formula',
          label: 'Formula'
        },
        {
          value: 'const',
          label: 'Const'
        }
      ],
      loading: false,
      expandedRows: [2],
      formDialog: false,
      compiledFormula: [],
      formulaName: '',
      customizationPage: '',
      options: {
        allowToRefetch: true,
        allowExporting: true
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    getHeaders() {
      return [
        {
          type: 'string',
          text: 'Tenant',
          value: 'DetailCompany.Company'
        },
        {
          type: 'string',
          text: 'Formula Name',
          value: 'VarName'
        },
        {
          type: 'string',
          text: 'Function',
          value: 'ProcessForm'
        },
        {
          type: 'string',
          text: 'Tags',
          value: 'Tags',
          cellTemplate: 'tagColumn'
        },
        {
          type: 'string',
          text: 'Action',
          value: 'Id',
          cellTemplate: 'commonAction'
        }
      ]
    },
    cancelForm() {
      this.formDialog = false
    },
    isExpanded(id) {
      return this.expanded[id]
    },
    addFormula() {
      this.addFormDialog = !this.addFormDialog
      this.typeForm = 'Add'
    },

    async fetchData() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.formula.getAllByAuthorize
        )
        this.sensorList = res.data
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async getCustomer() {
      try {
        this.loading = true
        const res = await this.$axios.get(this.$appInfo.api.customer.getAll)
        this.customerList = res.data
        // tmp
        this.getFormulaList()
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async getFormulaList() {
      try {
        this.loading = true
        const res = await this.$axios.get(this.$appInfo.api.formula.getAll)
        this.formulaList = res.data
        // tmp
        this.createDummyData()

        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    getRandomTags() {
      var totalTags = Math.floor(Math.random() * this.tags.length)
      var tags = []

      for (var i = 0; i < totalTags; i++) {
        tags.push({
          data: this.tags[Math.floor(Math.random() * this.tags.length)].label,
          color:
            this.tagsColor[Math.floor(Math.random() * this.tagsColor.length)]
        })
      }
      return tags
    },
    getRandomFormula() {
      // var totalFormula = Math.floor(Math.random() * this.tags.length)
      // var tags = []

      return this.formulaList[
        Math.floor(Math.random() * this.formulaList.length)
      ]
    },
    filterTags: function (data, filterString) {
      return data.some((x) => x.data === filterString)
    }
  }
}
</script>

<style>
.w-screen-xl {
  width: 1280px;
}
</style>
